// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:37
import { PersistentObject } from '../../SagaBase/PersistentObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class EventComplement_abstract extends PersistentObject {
  static $t: string = 'SagaSchema.EventComplement';
  $t: string = 'SagaSchema.EventComplement';

  public static GetMembers(): string[] {
    return ['EventId', 'AgencyId', 'MapLayers', 'ImageStream'].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return EventComplement_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public EventId: number = 0;
  public AgencyId: number = 0;
  public MapLayers: string;
  public ImageStream: any[];

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
